// Admin activity feed — labels for audit actions not covered in admin.js.
const en = {
  "admin.action.release_deleted_by_artist": "Artist removed a release",
  "admin.action.content_create": "Content created",
  "admin.action.content_update": "Content updated",
  "admin.action.content_archive": "Content archived",
  "admin.action.content_delete": "Content deleted",
  "admin.action.content_settings_update": "Content settings updated",
  "admin.action.upgrade_requested": "Plan upgrade requested",
  "admin.action.upgrade_request_approved": "Plan upgrade approved",
  "admin.action.upgrade_request_rejected": "Plan upgrade rejected",
  "admin.action.user_plan_changed": "Plan changed",
  "admin.action.rate_limiter_block": "IP blocked",
  "admin.action.rate_limiter_unblock": "IP unblocked",
};
const tr = {
  "admin.action.release_deleted_by_artist": "Sanatçı bir yayını kaldırdı",
  "admin.action.content_create": "İçerik oluşturuldu",
  "admin.action.content_update": "İçerik güncellendi",
  "admin.action.content_archive": "İçerik arşivlendi",
  "admin.action.content_delete": "İçerik silindi",
  "admin.action.content_settings_update": "İçerik ayarları güncellendi",
  "admin.action.upgrade_requested": "Plan yükseltme talebi",
  "admin.action.upgrade_request_approved": "Plan yükseltme onaylandı",
  "admin.action.upgrade_request_rejected": "Plan yükseltme reddedildi",
  "admin.action.user_plan_changed": "Plan değiştirildi",
  "admin.action.rate_limiter_block": "IP engellendi",
  "admin.action.rate_limiter_unblock": "IP engeli kaldırıldı",
};
const es = {
  "admin.action.release_deleted_by_artist": "El artista retiró un lanzamiento",
  "admin.action.content_create": "Contenido creado",
  "admin.action.content_update": "Contenido actualizado",
  "admin.action.content_archive": "Contenido archivado",
  "admin.action.content_delete": "Contenido eliminado",
  "admin.action.content_settings_update": "Ajustes de contenido actualizados",
  "admin.action.upgrade_requested": "Solicitud de mejora de plan",
  "admin.action.upgrade_request_approved": "Mejora de plan aprobada",
  "admin.action.upgrade_request_rejected": "Mejora de plan rechazada",
  "admin.action.user_plan_changed": "Plan cambiado",
  "admin.action.rate_limiter_block": "IP bloqueada",
  "admin.action.rate_limiter_unblock": "IP desbloqueada",
};
export default { en, tr, es };
